// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CommercialAgreement } from '@daml.js/utility-commercials-v0/lib/Utility/Commercials/V0/Model/CommercialAgreement';
import {
  ERR_MODIFY_COMMERCIAL_AGREEMENT,
  SUC_MODIFY_COMMERCIAL_AGREEMENT,
} from '../../../utils/strings';
import { useExerciseSubmission } from '../ledger/useSubmission';

export const useModifyCommercialAgreement = () => {
  const { submit } = useExerciseSubmission(
    CommercialAgreement.CommercialAgreement_Modify,
    SUC_MODIFY_COMMERCIAL_AGREEMENT,
    ERR_MODIFY_COMMERCIAL_AGREEMENT,
  );
  return submit;
};
